import axios, {AxiosPromise, AxiosResponse} from "axios";

import { auth } from "@/auth";
import store from "@/store/root";
import { Item } from "@/tools/msa/models/item";
import { Page, Session, Token } from "@/tools/msa/models";

export const calculateType = (item: Item): string =>
  item.type === "msa_custom"
    ? "-1"
    : item.type === "code_match"
    ? item.match.coding.type
    : item.type === "custom_match"
    ? item.match.coding.type
    : "-2";

export const calculateDisplay = (item: Item): string =>
  item.type === "code_match"
    ? item.match.coding.display
    : item.type === "msa_custom"
    ? item.name
    : "Not available";

export const getPages = (item: Item): Page[] =>
  item.type === "code_match"
    ? [
        ...new Set(
          item.match.locations
            .flatMap<Token>(location => location)
            .flatMap(token => token.occurrences)
            .filter(occurrence => occurrence.source === "page")
            .map(occurrence => (occurrence as any).page)
        )
      ]
    : [];

export const calculatePageNumbers = (item: Item): number[] =>
  item.type === "code_match"
    ? [
        ...new Set(
          item.match.locations
            .flatMap<Token>(location => location)
            .flatMap(token => token.occurrences)
            .filter(occurrence => occurrence.source === "page")
            .map(occurrence => (occurrence as any).page.number as number)
        )
      ]
    : [];

export const sendExportToTelemetry = async (
  session: Session,
  sessionId: string
) =>
  axios.post(
    "/msa",
    {
      fileId: session.fileId
    },
    {
      baseURL: (store.state as any).settings.current.endpoints.textractor,
      headers: { "X-Session-Id": sessionId, ...(await auth.headers()) }
    }
  );
